import Vue from 'vue'

class TicketItemTasks {
  async read({id}) {
    return await Vue.axios
      .get('app/ticket-item-tasks/' + id)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/ticket-item-tasks/' + id)
  }
}

const ticketItemTasks = new TicketItemTasks()

export default ticketItemTasks
